import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit";

import type { BucketsType } from "../types";
import type { GlobalState } from "../../store";

const initialState: BucketsType[] = [];

export const bucketsState = createSlice({
  name: "buckets",
  initialState,

  reducers: {
    setBuckets: (
      state: BucketsType[],
      action: PayloadAction<BucketsType[]>
    ) => {
      return action.payload;
    },
    updateOpenedBucket: (
      state: BucketsType[],
      action: PayloadAction<{
        id: number;
        opened: boolean;
        disabled: boolean;
        max?: number;
      }>
    ) => {
      return state.map((itm) => {
        if (itm.id === action.payload.id) {
          return {
            ...itm,
            opened: action.payload.opened,
            disabled: action.payload.disabled,
            max: action.payload.max ?? itm.max,
          };
        } else {
          return { ...itm };
        }
      });
    },
    updateBucketMin: (
      state: BucketsType[],
      action: PayloadAction<{ id: number; min: number }>
    ) => {
      return state.map((itm) => {
        if (itm.id === action.payload.id) {
          return {
            ...itm,
            min: action.payload.min,
          };
        } else {
          return { ...itm };
        }
      });
    },
    updateBucketMax: (
      state: BucketsType[],
      action: PayloadAction<{ id: number; max: number }>
    ) => {
      return state.map((itm) => {
        if (itm.id === action.payload.id) {
          return {
            ...itm,
            max: action.payload.max,
          };
        } else {
          return { ...itm };
        }
      });
    },
    setBucketMaxCountReached: (
      state: BucketsType[],
      action: PayloadAction<{ id: number; isMaxCountReached: boolean }>
    ) => {
      return state.map((itm) => {
        if (itm.id === action.payload.id) {
          return {
            ...itm,
            isMaxCountReached: action.payload.isMaxCountReached,
          };
        } else {
          return { ...itm };
        }
      });
    },
  },
});

const selector = (s: GlobalState) => s.data.purchaseSeats.buckets;

export const selectBuckets = createSelector(selector, (s) => s);

export const { setBuckets, updateOpenedBucket } = bucketsState.actions;
export default bucketsState.reducer;
